<template>
    <a-button @click="visible = true" icon="akar-icons:plus" class="!tw-border-b tw-scale-75  tw-ms-auto lg:tw-m-0" intent="icon"></a-button>

    <a-popup :visible="visible" @cancel="onCancel">
        <div
            class="tw-mx-auto tw-w-[95%] md:tw-max-w-[800px]  tw-h-fit tw-overflow-auto tw-flex tw-flex-col tw-border tw-border-solid dark:tw-border-gray-400 tw-border-gray-300 tw-shadow-md tw-my-16 tw-rounded">
            <div>
                <div
                    class="tw-p-4 tw-text-lg tw-flex tw-items-center tw-gap-2 tw-border-b tw-border-solid tw-font-semibold dark:tw-text-gray-700 tw-text-gray-500 dark:tw-bg-gray-100 tw-bg-gray-50">
                    <span>{{ $t("common.cross-product") }}</span>
                </div>

                <div class="tw-p-5 tw-bg-white tw-flex-1">
                    <div class="tw-grid tw-grid-cols-12 tw-gap-x-4 tw-gap-y-0">
                        <div class="tw-col-span-12 md:tw-col-span-12">
                            <form-vue-select hide-errors :label="$t('fields.product')" v-model="crossProduct.cross_product_id"
                                @option:selected="() => crossProduct.product_variant_id = null" option-value="id" :options="products"
                                class="tw-bg-whitex">
                                <template v-slot:selected="{ option }">
                            <div v-if="option.id">
                            <p class="tw-max-w-[120px] tw-truncate tw-text-xs">{{ option.name }}</p>
                            </div>
                            <div v-else>
                            <p class="tw-max-w-[120px] tw-truncate tw-text-xs">{{ $t('common.none') }}</p>
                            </div>
                        </template>

                        <template v-slot:option="{ option }">
                            <div v-if="option.id">
                            <p class="tw-max-w-[120px] tw-truncate tw-text-xs">{{ option.name }}</p>
                            </div>
                            <div v-else>
                            <p class="tw-max-w-[120px] tw-truncate tw-text-xs">{{ $t('common.none') }}</p>
                            </div>
                        </template>
                        </form-vue-select>
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-12">
                            <FormField v-model="crossProduct.price" :label="$t('fields.price')" type="number"
                                :error="errors.price &&
                                    $t('errors.' + errors.price, {
                                        field: $t('fields.price'),
                                    })
                                    " />
                        </div>

                        <div class="tw-col-span-12 md:tw-col-span-12">
                            <FormField v-model="crossProduct.note" :label="$t('fields.note')" type="textarea"
                                :error="errors.note &&
                                    $t('errors.' + errors.note, {
                                        field: $t('fields.note'),
                                    })
                                    " />
                        </div>

                    </div>
                </div>

                <div
                    class="tw-p-4 tw-text-lg tw-border-t tw-justify-end tw-border-solid tw-font-medium tw-flex dark:tw-text-gray-700 tw-text-gray-500 tw-items-center tw-gap-4 dark:tw-bg-gray-100 tw-bg-gray-50">
                    <a-button @click="onCancel" class="tw-min-w-[120px]" intent="simple">{{
                        $t("buttons.cancel") }}</a-button>
                    <a-button  @click="onCreate" class="tw-min-w-[120px]">{{
                        $t("buttons.create") }}</a-button>
                </div>
            </div>
        </div>
    </a-popup>

</template>

<script setup>
import FormField from "@/components/form/FormField";
import FormVueSelect from "@/components/form/FormVueSelect";
import { useStateStore } from '@/stores/app/state';
import { computed, ref, defineEmits } from 'vue';


const visible = ref(false);
const  emit = defineEmits(['created']);
const stateStore = useStateStore();
const products = computed(() => [{ id: null }, ...stateStore.products.map(p => ({ ...p, label: p.name }))]);

const errors = ref({});
const crossProduct = ref({
    cross_product_id: null,
    note: '',
    price: 0,
});

const onCreate = () => {
    console.log(crossProduct.value);
    if(!crossProduct.value.price) {
        errors.value = {
            price: !crossProduct.value.price ? 'required' : null,
        };
        return;
    }
    // add random id to crossProduct
    crossProduct.value.id = Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15);

    crossProduct.value.created = true;
    errors.value = {};
    console.log('crossProduct.value: ', crossProduct.value);
    
    emit('created', crossProduct.value);
    crossProduct.value = {
        cross_product_id: null,
        note: '',
        price: 0,
    };
    
    visible.value = false;
}

const onCancel = () => {
    visible.value = false;
}


</script>

<style></style>
